import { API_ORIGIN } from "../config/api";

export async function api(path, init) {
  const base = API_ORIGIN;
  const res = await fetch(`${base}${path}`, {
    headers: { "Content-Type": "application/json", ...(init?.headers || {}) },
    ...(init || {}),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }
  return await res.json();
}
